'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const ModalView = require('common/ui/view/modal/index');
const Dialog = require('common/util/dialog');
const Action = require('process/domain/entity/action');
const ActionDeleteService = require('process/app/service/action/delete');
const ActionCreateView = require('process/ui/view/action/setting');
const ContentEditView = require('balus/ui/view/body/process/toolbar/content-edit');
const DiagramEditView = require('balus/ui/view/body/process/toolbar/diagram-edit');
const ContainerRepository = require('data/domain/repository/container/index');
const SidebarNavListView = require('common/ui/view/sidebar/nav');
const ContentActionWorkCreateService = require('balus/app/service/actionwork/content/create');
const ContentActionWorkAddService = require('balus/app/service/actionwork/content/add');
const DiagramActionWorkCreateService = require('balus/app/service/actionwork/diagram/create');
const DiagramActionWorkAddService = require('balus/app/service/actionwork/diagram/add');
const ActionImportService = require('balus/app/service/action/import');
const Template = require('balus/ui/template/body/process/toolbar/index.hbs');
const ViewerRepository = require('balus/domain/repository/viewer');
const ViewerListView = require('balus/ui/view/viewer/list');
const DataContentSelectorView = require('balus/ui/view/modal/data-content-selector');
const Router = require('balus/app/router/index');
const ActionSettingView = require('process/ui/view/action/setting');
const ProcessPermission = require('process/domain/entity/permission');

const ImportActionTemplateFilePath = require('file-loader?name=process/[name].[ext]!process/import-actions.xls');


module.exports = Mn.View.extend({
    template: Template,
    regions: {
        nav: '.sidebar-nav',
        viewer: '.viewers',
        importFileSelector: '.import-file-selector'
    },
    ui: {
        actionEditButton: '.action-edit-button',
        actionAddButton: '.action-add-button',
        actionDeleteButton: '.action-delete-button',
        actionImportButton: '.action-import-button',
        contentAddButton: '.content-add-button',
        diagramAddButton: '.diagram-add-button'
    },
    events: {
        'click @ui.actionEditButton': 'editAction',
        'click @ui.actionAddButton': 'addAction',
        'click @ui.actionDeleteButton': 'deleteAction',
        'click @ui.actionImportButton': 'showImportAction',
        'click @ui.contentAddButton': 'addContent',
        'click @ui.diagramAddButton': 'addDiagram'
    },

    templateContext: function() {
        const context = this.getOption('context');
        return {
            isEditable: context.getProjectRole().getPermission(
                ProcessPermission.ActionEditPermission
            ).isPermitted(context),
            subActionAddable: !this.model.isMaxLevel() && context.getProjectRole().getPermission(
                ProcessPermission.ActionCreatePermission
            ).isPermitted(context),
            subActionImportable: !this.model.isMaxLevel() && context.getProjectRole().getPermission(
                ProcessPermission.ActionBulkImportPermission
            ).isPermitted(context)
        }
    },

    onRender: function() {
        const context = {
            projectId: this.getOption('context').getProject().id,
            actionId: this.model.id
        };

        const viewers = ViewerRepository.getViewer(context);
        this.showChildView('viewer', new ViewerListView({
            viewers: viewers.getUsers(),
            user: this.getOption('context').getUser()
        }));

        const project = this.model.getProject();
        ContainerRepository.find(project)
            .fetchRootOnce()
            .then(rootContainer => {
                if (rootContainer.id) {
                    this.ui.contentAddButton.show();
                }
            });

        this.showChildView('importFileSelector', new DataContentSelectorView({
            project: this.getOption('context').getProject(),
            hideURLInput: true,
            accept: ['xls'],
            title: i18n.t('balus_template_body_process:toolbar.import-subaction'),
            messagePanelContent: i18n.t(
                'balus_template_body_process:toolbar.import-subaction-sample-download',
                {url: `${ImportActionTemplateFilePath}?t=${(new Date()).getTime()}`})
        }));
        this.listenTo(this.getChildView('importFileSelector'), 'select', function(content) {
            this.importAction(content);
        });
    },

    renderNav: function(navs) {
        this.showChildView('nav', new SidebarNavListView({
            collection: navs,
            horizontal: true
        }));
    },

    editAction: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('process:action-setting.update'),
            saveButtonDisable: true,
            bodyView: new ActionSettingView({
                context: this.getOption('context'),
                model: this.model,
                project: this.model.getProject()
            }),
            large: true,
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    })
                    .catch(() => {
                        this.enableButtons();
                    });
            }
        });
        modal.on('insert', content => {
            (new ContentActionWorkAddService(
                this.model, [content.id], 'out'
            ))
                .add();
        });
        modal.show();
    },

    addAction: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('process:action-setting.create'),
            bodyView: new ActionCreateView({
                context: this.getOption('context'),
                model: new Action(),
                project: this.model.getProject(),
                parent: this.model
            }),
            large: true,
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').save()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    deleteAction: function() {
        Dialog.confirm({
            text: i18n.t('process:dialog.deleteConfirm', {name: this.model.get('name')}),
            okCallback: () => {
                (new ActionDeleteService(this.model.getProject(), this.model.id))
                    .delete()
                    .then(() => {
                        Router.navigateProcessDashboard(this.model.getProject());
                    });
            }
        });
    },

    addContent: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('balus_template_body_process:modal.add-data.title'),
            bodyView: new ContentEditView({
                context: this.getOption('context'),
                project: this.model.getProject(),
                // ContentEditView は body/process/toolbar 配下に実装されているが、
                // Timeline の AdditionalView からも参照されているので、
                // Action画面のツールバーから呼ばれていることを確実に判断するためのフラグを渡す
                inActionToolbar: true,
            }),
            onChildviewSave: function() {
                this.disableButtons();
                const activeContents = this.getOption('bodyView').getActiveContents();
                const contentJSON = this.getOption('bodyView').getContent();
                if(activeContents && activeContents.length > 0) {
                    (new ContentActionWorkAddService(this.model, activeContents, 'out'))
                        .add()
                        .then(() => {
                            this.hide();
                        });
                } else {
                    (new ContentActionWorkCreateService(this.model, contentJSON, 'out'))
                        .create()
                        .then(() => {
                            this.hide();
                        });
                }
            }
        });
        modal.show();
    },

    addDiagram: function() {
        const modal = new ModalView({
            model: this.model,
            title: i18n.t('balus_template_body_process:modal.add-model.title'),
            bodyView: new DiagramEditView({
                group: this.getOption('context').getGroup(),
                project: this.model.getProject()
            }),
            onChildviewSave: function() {
                this.disableButtons();
                const activeDiagrams = this.getOption('bodyView').save();
                if(activeDiagrams.length > 0) {
                    (new DiagramActionWorkAddService(this.model, activeDiagrams, 'out'))
                        .add()
                        .then(() => {
                            this.hide();
                        }).catch((status) => {
                            this.getOption('bodyView').error(status);
                            this.enableButtons();
                        });
                } else {
                    (new DiagramActionWorkCreateService(this.model, this.getOption('bodyView').model.toJSON(), 'out'))
                        .create()
                        .then(() => {
                            this.hide();
                        }).catch((status) => {
                            this.getOption('bodyView').error(status);
                            this.enableButtons();
                        });
                }
            }
        });
        modal.show();
    },

    showImportAction: function() {
        this.getChildView('importFileSelector').show();
    },

    importAction: function(content) {
        (new ActionImportService(this.model, content.getLatestVersion()))
            .import()
            .then(importAction => {
                const importId = importAction['id'];
                Router.navigateProcessImport(this.model.getProject(), this.model, importId);
                this.getChildView('importFileSelector').hide();
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/toolbar/index.js